import axios from "lib/axios";

const getTimelines = async ({ frequency, band }) => {
  const { data } = await axios.get(
    `/timelines?band=${band}&frequency=${frequency}`
  );
  return data;
};

const getTimeline = async (timelineId) => {
  const { data } = await axios.get(
    `/timeline/${timelineId}`
  );
  return data;
};

const searchTimelines = async ({ searchQuery, band }) => {
  const { data } = await axios.get(
    `/timelines?band=${band}&s=${searchQuery}`
  );
  return data;
};

const exploreTimelines = async ({ keyTimelineId, band }) => {
  const { data } = await axios.get(
    `/explorer?k=${keyTimelineId}&band=${band}`
  );
  return data;
};

const getLyrics = async ({ timelineId }) => {
  const { data } = await axios.get(
    `/timeline/${timelineId}/lyrics`
  );
  return data;
};

export {getTimelines, getTimeline, searchTimelines, exploreTimelines, getLyrics };
